import { render, staticRenderFns } from "./SupportUs.vue?vue&type=template&id=4f713cc8&scoped=true&"
import script from "./SupportUs.vue?vue&type=script&lang=js&"
export * from "./SupportUs.vue?vue&type=script&lang=js&"
import style0 from "./SupportUs.vue?vue&type=style&index=0&id=4f713cc8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f713cc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VMain,VRow})
